export default [
  {
    path: '/goga-rank-word-pool',
    component: () => import('./views/Index'),
    name: 'goga-rank-word-pool',
    redirect: { name: 'goga-rank-word-pool-list' },
    children: [
      {
        path: 'words',
        name: 'goga-rank-word-pool-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
